import { render, staticRenderFns } from "./AudioItem.vue?vue&type=template&id=9f8e5710"
import script from "./AudioItem.vue?vue&type=script&lang=js"
export * from "./AudioItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports